/* eslint-disable no-console */
import wrapper from 'wrapper';
import '../app/components/manifesto/manifesto';

wrapper.select('.js').style.display = "block";
wrapper.markPageAsLoaded();
